import { API } from "src/constants";

import { Http } from "../http";

import { VacancyResponse } from "./vacancy.types";

export const getVacancyContent = (url: string): VacancyResponse =>
  Http.get(`${API}/${url}`);
